export type InAppBrowser = "instagram" | "facebook" | "tiktok";

/** The social app whose built-in browser is showing the page, if any. */
export function detectInAppBrowser(userAgent: string): InAppBrowser | null {
  if (/Instagram/i.test(userAgent)) return "instagram";
  if (/FBAN|FBAV|FB_IAB|Messenger/i.test(userAgent)) return "facebook";
  if (/musical_ly|BytedanceWebview|TikTok/i.test(userAgent)) return "tiktok";

  return null;
}

/** An Android intent link that opens an https url in the default browser; null for any other url. */
export function buildExternalBrowserIntentUrl(url: string): string | null {
  const { protocol, host, pathname, search, hash } = new URL(url);
  if (protocol !== "https:") return null;

  return `intent://${host}${pathname}${search}${hash}#Intent;scheme=https;S.browser_fallback_url=${encodeURIComponent(url)};end`;
}
